import { render, staticRenderFns } from "./ReleaseNotesPage.vue?vue&type=template&id=1d996fde&scoped=true&"
import script from "./ReleaseNotesPage.vue?vue&type=script&lang=js&"
export * from "./ReleaseNotesPage.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseNotesPage.vue?vue&type=style&index=0&id=1d996fde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d996fde",
  null
  
)

export default component.exports